export const forceFetch = (state = false, action) => {
  return action.type === "FORCE_FETCH" ? action.value : state;
};

export const forceFetchQueue = (state = false, action) => {
  return action.type === "FORCE_FETCH_QUEUE" ? action.value : state;
};
